export default "__VITE_ASSET__BCO9qLbg__"